import { render, staticRenderFns } from "./OpenReviewsCard.vue?vue&type=template&id=3bc13e1c"
import script from "./OpenReviewsCard.vue?vue&type=script&lang=js"
export * from "./OpenReviewsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports